// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Ym-z","badgeLink":"Zm-z","category":"_m-z"};